import sideBarCardService from './sideBarCardService'

const consolidatedQuestionsService = {
    $sections: [],
    currentSectionIndex: -1,
    run() {
        this.$sections = $('.consolidated-section');
        if (this.$sections.length > 0) {
            this.runActiveSectionListener()
            this.setActiveSection(this.getSectionForScrollPosition())
        }
    },
    setActiveSection(activeSectionIndex) {
        if (this.currentSectionIndex !== activeSectionIndex) {
            this.currentSectionIndex = activeSectionIndex
            this.showSidebarCardsForCurrentSection()
            this.addActiveClassToCurrentSection()
        }
    },
    runActiveSectionListener() {
        document.addEventListener('scroll', (e) => {
            this.setActiveSection(this.getSectionForScrollPosition())
        });
    },
    getSectionForScrollPosition() {
        // section is active if it crosses 50% threshold of visible screen
        // @see https://bikmo.slack.com/archives/C04D6DH82HK/p1670841982169089
        const visibleScreenHeight = $(window.top).height();
        const threshold = visibleScreenHeight / 2;
        let lastSectionAboveThreshold = 0;
        for (let i = 0; i < this.$sections.length; i++) {
            const sectionTitle = $(this.$sections[i]).find('h1')[0]
            const titleBoundingRect = sectionTitle.getBoundingClientRect()
            if (titleBoundingRect.y < threshold) {
                lastSectionAboveThreshold = i;
            }
        }
        return lastSectionAboveThreshold;
    },
    getCurrentSectionQuestionSlugs() {
        const $section = $(this.$sections[this.currentSectionIndex])
        return $section.find('.question').map((i, q) => q.dataset['question']).toArray();
    },
    showSidebarCardsForCurrentSection() {
        sideBarCardService.showCardsForQuestions(this.getCurrentSectionQuestionSlugs())
    },
    addActiveClassToCurrentSection() {
        this.$sections.removeClass('active')
        $(this.$sections[this.currentSectionIndex]).addClass('active')
    }
}

consolidatedQuestionsService.run()
